var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"real-container"},[(_vm.isRouterAlive)?_c('router-view',{staticClass:"content"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }